module.exports = __webpack_public_path__ + "static/learning-secondary@large-c498bc23800c274e42da30e86c3b136b.jpg";